export default __webpack_public_path__ + "static/media/MeadlightBottle.3cfdec05.glb";